// extracted by mini-css-extract-plugin
export default {"article":"_1MjCInJ9STcL6nLynJ3I4S","popupArticle":"_1FJB2YyA8_AUdUJc01Onuq","header":"_2-ZlPx8R4W72SG7WKjp0Ca","text":"_38oy8ebA4w5F9vgP8ieDSk"};